import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from '../store'
import UserActivity from 'model/UserActivity'
import UserActivityRepository from 'clients/db/UserActivityRepository'

interface UserActivityState {
  isLoading: boolean
  userActivity: UserActivity
  saveOnIdle: boolean
}

const initialState: UserActivityState = {
  isLoading: false,
  userActivity: {} as UserActivity,
  saveOnIdle: false,
}

function startLoading(state: UserActivityState) {
  state.isLoading = true
}

const userActivitySlice = createSlice({
  name: 'userActivity',
  initialState,
  reducers: {
    createUserActivityStart: startLoading,
    updateUserActivityStart: startLoading,
    createUserActivitySuccess(state, { payload }: PayloadAction<UserActivity>) {
      state.isLoading = false
      state.userActivity = payload
    },
    updateUserActivitySuccess(state, { payload }: PayloadAction<UserActivity>) {
      state.isLoading = false
      state.userActivity = payload
    },
    executeIdleSave(state: UserActivityState, { payload }: PayloadAction<boolean>) {
      state.saveOnIdle = payload
    },
  },
})

export const {
  createUserActivityStart,
  createUserActivitySuccess,
  updateUserActivityStart,
  updateUserActivitySuccess,
  executeIdleSave,
} = userActivitySlice.actions

export const createUserActivity = (
  userActivity: UserActivity,
  onSuccess?: (userActivity: UserActivity) => void,
): AppThunk => async (dispatch) => {
  dispatch(createUserActivityStart())
  const newUserActivity = await UserActivityRepository.save(userActivity)
  dispatch(createUserActivitySuccess(newUserActivity))

  if (onSuccess) {
    onSuccess(newUserActivity)
  }
}

export const updateUserActivity = (
  userActivity: UserActivity,
  onSuccess?: (userActivity: UserActivity) => void,
): AppThunk => async (dispatch) => {
  dispatch(updateUserActivityStart())
  const updatedUserActivity = await UserActivityRepository.saveOrUpdate(userActivity)

  dispatch(updateUserActivitySuccess(updatedUserActivity))
  if (onSuccess) {
    onSuccess(updatedUserActivity)
  }
}

export const idleSave = (save: boolean): AppThunk => async (dispatch) => {
  dispatch(executeIdleSave(save))
}

export default userActivitySlice.reducer
